module.exports = __webpack_public_path__ + "media/newstyle/images/icon-download-1e08694a7c5ccfc23bfdf8e7d13a6b71.svg";